<div class="wrapper wrapper-content animated fadeInRight">
  <div class="row">
    <div class="col-lg-12">
      <div class="ibox float-e-margins">
        <div class="ibox-title">
          <h5>System Dashboard</h5>
        </div>
        <div class="ibox-content">
          <div class="row">
            <div class="col-md-12">
              <h4>Admin Session</h4>
              <div class="mt-3">
                <div class="form-group row">
                  <label class="col-sm-2 control-label"
                    >Session Identifier:</label
                    >
                    <div class="col-sm-10">
                      <div class="toolbar-group">
                        <input
                          type="text"
                          class="form-control guid-input"
                          readonly
                          [value]="adminSessionGuid"
                          id="adminSessionGuid"
                          />
                          <button
                            class="btn btn-default guid-copy-btn"
                            type="button"
                            (click)="copyGuidToClipboard()"
                            title="Copy to clipboard"
                            aria-label="Copy admin session identifier to clipboard"
                            >
                            <i class="fa fa-copy"></i>
                          </button>
                        </div>
                      </div>
                    </div>
                    @if (adminSessionGuid) {
                      <div class="form-group row">
                        <label class="col-sm-3 control-label">Actions:</label>
                        <div class="col-sm-9">
                          <button
                            class="btn btn-outline-primary btn-sm me-2"
                            (click)="regenerateSessionGuid()"
                            >
                            <i class="fa fa-refresh"></i> Regenerate Identifier
                          </button>
                        </div>
                      </div>
                    }
                  </div>
                  @if (adminSessionGuid) {
                    <div class="mt-4">
                      <div class="alert alert-info">
                        <strong>Admin Session:</strong> This token/value uniquely
                        identifies your session and can be used for debugging and
                        troubleshooting.
                      </div>
                    </div>
                  }
                </div>
              </div>

              <div class="mt-4 text-center system-dashboard-buttons">
                <a routerLink="/system/real-time-events" class="btn btn-primary">
                  <i class="fa fa-bell"></i> View Real-Time Events
                </a>
                <a routerLink="/system/config" class="btn btn-info">
                  <i class="fa fa-cog"></i> View Configuration
                </a>
                <a routerLink="/system/simulator" class="btn btn-success">
                  <i class="fa fa-play-circle"></i> Simulator
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
